import React, { useCallback, useEffect, useRef, useState } from "react";
import { Smartphone, Upload, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, API, formatApiError } from "@/lib/api";

const KINDS = [
  { kind: "app_icon", label: "Ícone do app instalado", hint: "Quadrado, 512×512px ou maior." },
  { kind: "favicon", label: "Favicon (aba do navegador)", hint: "Quadrado, PNG com fundo transparente." },
];

export default function IconManager() {
  const [icons, setIcons] = useState({});
  const refs = useRef({});

  const load = useCallback(async () => {
    try { const r = await api.get("/settings"); setIcons(r.data.icons || {}); } catch (e) { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onFile = async (kind, e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post(`/admin/icon/${kind}`, fd); await load(); toast.success("Ícone atualizado!"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const remove = async (kind) => {
    try { await api.delete(`/admin/icon/${kind}`); await load(); toast.success("Ícone padrão restaurado."); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="mb-8" data-testid="icon-manager">
      <div className="flex items-center gap-2">
        <Smartphone className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Ícone do app e favicon</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Quem já instalou o app pode precisar reinstalar para ver o novo ícone.</p>
      <div className="mt-3 grid max-w-xl grid-cols-1 gap-3 sm:grid-cols-2">
        {KINDS.map(({ kind, label, hint }) => {
          const info = icons[kind] || {};
          return (
            <div key={kind} className="rounded-2xl border border-slate-200 bg-white p-3">
              <div className="flex items-center gap-3">
                <img data-testid={`icon-preview-${kind}`} src={`${API}/settings/icon/${kind}?size=128&v=${encodeURIComponent(info.updated_at || "")}`} alt="" className="h-16 w-16 rounded-2xl border border-slate-200 bg-slate-50 object-contain" />
                <div><p className="text-sm font-bold text-slate-800">{label}</p><p className="text-xs text-slate-500">{hint}</p></div>
              </div>
              <input ref={(el) => (refs.current[kind] = el)} type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => onFile(kind, e)} className="hidden" data-testid={`icon-input-${kind}`} />
              <div className="mt-2 flex gap-2">
                <Button data-testid={`icon-upload-${kind}`} onClick={() => refs.current[kind]?.click()} size="sm" className="flex-1 rounded-xl bg-[#1B7A45] text-white hover:bg-[#156337]"><Upload className="mr-1 h-4 w-4" /> Enviar</Button>
                {info.present && <Button data-testid={`icon-remove-${kind}`} onClick={() => remove(kind)} size="sm" variant="outline" className="rounded-xl border-red-200 bg-red-50 text-red-600"><Trash2 className="h-4 w-4" /></Button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
